export default __webpack_public_path__ + "static/media/ilahi.067a2d14.jpg";